import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getUrlParams, getGoqiiUserId } from "../apiService/timespam";
import { lifestyleApi } from "../apiService/api";
import CalendarHome from "../Components/CalendarHome";
import "./Theme.css";
import "./TreatmentPlan.css";

const TreatmentPlan = () => {
  const { t } = useTranslation();
  const { theme, lang } = getUrlParams();
  const urlParams = new URLSearchParams(window.location.search);
  const goqiiUserId = getGoqiiUserId();
  const action = urlParams.get("action") || "";

  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split("T")[0]);
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [theme, lang]);

  const fetchPlans = async (date) => {
    setLoading(true);
    try {
      const res = await lifestyleApi.fetchTreatmentPlan({ selectedDate: date });
      setPlans(res.data.data || []);
    } catch (err) {
      // fetchTreatmentPlan error
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchPlans(selectedDate); }, [selectedDate]);

  const handleDateSelect = (date) => { setSelectedDate(date); };

  const togglePlan = async (plan) => {
    if (action === "N") return;
    try {
      await lifestyleApi.saveTreatmentPlan({
        attrmasterid: plan.attrmasterid,
        attrsubid: plan.attrsubid,
        isActive: plan.isActive === "Y" ? "N" : "Y",
        selectedDate,
      });
      fetchPlans(selectedDate);
    } catch (err) {
      // saveTreatmentPlan error
    }
  };

  return (
    <section className="tp-page">
      <div className="tp-calendar">
        <CalendarHome onDateSelect={handleDateSelect} />
      </div>
      <div className="tp-plans">
        {loading ? (
          <p className="tp-loading">{t("common.loading")}</p>
        ) : plans.length === 0 ? (
          <p className="tp-empty">{t("treatmentPlan.noPlans")}</p>
        ) : (
          plans.map((plan, i) => (
            <div key={i} className="tp-plan-card" onClick={() => togglePlan(plan)}>
              <div className="tp-plan-info">
                <h3 className="tp-plan-name">{plan.attributeName || plan.name}</h3>
                <p className="tp-plan-sub">{plan.attrsubName || ""}</p>
              </div>
              <div className={`tp-tick ${plan.isActive === "Y" ? "tp-tick--done" : ""}`}>
                {plan.isActive === "Y" ? "✓" : ""}
              </div>
            </div>
          ))
        )}
      </div>
    </section>
  );
};

export default TreatmentPlan;
